import { useLocation } from 'react-use'
import { getLangBasePath, getPathPrefix } from '../helpers/routing'

export const usePathPrefix = link => {
  const location = useLocation()
  const lang = getLangBasePath(location)

  if (link && link.url && ['de', 'fr', 'it'].includes(link.url.split('/')[3])) {
    return '/' + link.url.trim('/').split('/')[3]
  }

  return getPathPrefix(lang)
}
